import { render, staticRenderFns } from "./questionOrder.vue?vue&type=template&id=5047b2ad&scoped=true"
import script from "./questionOrder.vue?vue&type=script&lang=js"
export * from "./questionOrder.vue?vue&type=script&lang=js"
import style0 from "./questionOrder.vue?vue&type=style&index=0&id=5047b2ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5047b2ad",
  null
  
)

export default component.exports